const tr_school = {
  name: "Okul",
  language: "tr",
  profile: "school",
  components: [
    {
      type: "headerimagecomponent",
      data: {
        type: "logo",
        name: "Kunduz Logo",
        image: null,
        alt_text: "Kunduz",
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Kullanıcılar",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "Öğrenci",
            type: null,
            url: "/tr/",
            icon: "users-03",
            description: "Hedeflediğin netler için ihtiyacın olan herşey!",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Okul",
            type: null,
            url: "/tr/okul/",
            icon: "building-08",
            description: "Kurumunuzu Kunduz'la geleceğe taşıyın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Eğitmen",
            type: null,
            url: "/tr/egitmen/",
            icon: "pen-tool-01",
            description: "Soru çözerek ek kazanç sağlayın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Kurumsal Panel Giriş",
        url: "/auth/login/?returnUrl=/u/",
        target: "_self",
        icon: null,
        type: "secondary",
        desktop_position: "right",
        mobile_position: null,
        hide_for_authenticated_user: true,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Özellikler",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "7/24 Soru Çözüm",
            type: null,
            url: "/tr/#soru_cozum",
            icon: "infinity",
            description: "Çözemediğin soru kalmasın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Eğitmenlerle Birebir Görüşme",
            type: null,
            url: "/tr/#birebir_gorusme",
            icon: "message-chat-circle",
            description: "Aklında soru işareti bırakma.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Video Konu Anlatımları",
            type: null,
            url: "/tr/#konu_anlatim",
            icon: "play-circle",
            description: "Ezberlemeden öğren.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Akıllı Testler",
            type: null,
            url: "/tr/#akilli_testler",
            icon: "book-open-01",
            description: "Sorularla konuları pekiştir.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Grup Rehberlik",
            type: null,
            url: "/tr/#grup_kocluk",
            icon: "hearth-hand",
            description: "Diğer öğrencilerin deneyimlerinden faydalan.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "İletişime Geçin",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfBNm3Vcti2WZOrtRHcyP18TogC-Ph4QqGuuRUc9ano-dCvwQ/viewform",
        target: "_blank",
        icon: null,
        type: "primary",
        desktop_position: "right",
        mobile_position: "bottom",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "İletişime Geçin",
        url: "https://docs.google.com/forms/d/e/1FAIpQLSfBNm3Vcti2WZOrtRHcyP18TogC-Ph4QqGuuRUc9ano-dCvwQ/viewform",
        target: "_blank",
        icon: null,
        type: "primary",
        desktop_position: null,
        mobile_position: "right",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "İçerikler",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Hakkımızda",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "Blog",
            type: null,
            url: "/tr/blog/",
            icon: "book-closed",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Biz Kimiz?",
            type: null,
            url: "/tr/hakkimizda/",
            icon: "users-03",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Bize Ulaşın",
            type: null,
            url: "/tr/iletisim/",
            icon: "phone",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Sıkça Sorulan Sorular",
            type: null,
            url: "/tr/sss/",
            icon: "life-buoy-02",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Paketleri İncele",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [],
        desktop_position: null,
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Lisans Aktifleştir",
        type: null,
        url: "/tr/basla/",
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [],
        desktop_position: null,
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Hesap",
        type: null,
        url: "/u/student/stats/",
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [],
        desktop_position: null,
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: true,
      },
    },
  ],
};
const tr_student = {
  name: "Öğrenci",
  language: "tr",
  profile: "student",
  components: [
    {
      type: "headerbuttoncomponent",
      data: {
        label: "",
        url: "",
        target: null,
        icon: null,
        type: null,
        desktop_position: null,
        mobile_position: null,
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerimagecomponent",
      data: {
        type: "logo",
        name: "Kunduz Logo",
        image: null,
        alt_text: "Kunduz",
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Kullanıcılar",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "Öğrenci",
            type: null,
            url: "/tr/",
            icon: "users-03",
            description: "Hedeflediğin netler için ihtiyacın olan herşey!",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Okul",
            type: null,
            url: "/tr/okul/",
            icon: "building-08",
            description: "Kurumunuzu Kunduz'la geleceğe taşıyın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Eğitmen",
            type: null,
            url: "/tr/egitmen/",
            icon: "pen-tool-01",
            description: "Soru çözerek ek kazanç sağlayın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Görüşme Başlat",
        url: "https://api.whatsapp.com/message/MTC3HT3IOCM4K1?autoload=1&app_absent=0",
        target: "_blank",
        icon: "whatsapp",
        type: "secondary",
        desktop_position: null,
        mobile_position: "bottom",
        hide_for_authenticated_user: true,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "",
        url: "",
        target: null,
        icon: null,
        type: null,
        desktop_position: null,
        mobile_position: null,
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Özellikler",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "7/24 Soru Çözüm",
            type: null,
            url: "/tr/soru-cozum/",
            icon: "infinity",
            description: "Çözemediğin soru kalmasın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Eğitmenlerle Birebir Görüşme",
            type: null,
            url: "/tr/#birebir_gorusme",
            icon: "message-chat-circle",
            description: "Aklında soru işareti bırakma.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Bire Bir Koçluk",
            type: null,
            url: "/tr/bire-bir-kocluk",
            icon: "hearth-hand",
            description: "Sana özel koçunla çalış.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Canlı Grup Dersleri",
            type: null,
            url: "/tr/canli-ders/",
            icon: "calendar-check-01",
            description: "Uzman eğitmenlerle interaktif sınav hazırlığı.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },

          {
            title: "Deneme Kulübü",
            type: null,
            url: "/tr/deneme-kulubu/",
            icon: "check-verified-02",
            description: "Bol bol deneme ile gerçek sınav provası",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Kişiye Özel Soru Bankası",
            type: null,
            url: "/tr/kisiye-ozel-soru-bankasi/",
            icon: "book-open-01",
            description:
              "Deneme analizlerine göre sana özel hazırlanan kitaplar",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Video Konu Anlatımları",
            type: null,
            url: "/tr/#konu_anlatim",
            icon: "play",
            description: "Ezberlemeden öğren.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Akıllı Testler",
            type: null,
            url: "/tr/#akilli_testler",
            icon: "lightbulb-05",
            description: "Sorularla konuları pekiştir.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Grup Rehberlik Seansları",
            type: null,
            url: "/tr/#grup_kocluk",
            icon: "users-03",
            description: "Diğer öğrencilerin deneyimlerinden faydalan.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Giriş Yap",
        url: "/auth/login/",
        target: "_self",
        icon: null,
        type: "tertiary",
        desktop_position: "right",
        mobile_position: null,
        hide_for_authenticated_user: true,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Lisans Aktifleştir",
        url: "/basla/",
        target: "_self",
        icon: null,
        type: "tertiary",
        desktop_position: "right",
        mobile_position: null,
        hide_for_authenticated_user: true,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Giriş Yap",
        url: "/auth/login/",
        target: "_self",
        icon: null,
        type: "secondary",
        desktop_position: null,
        mobile_position: "bottom",
        hide_for_authenticated_user: true,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Paketleri İncele",
        type: "blue_gradient",
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "YKS 2026",
            type: null,
            url: "/tr/paketler/yks-2026/",
            icon: null,
            description: null,
            badge_text: "ERKEN KAYIT FIRSATI",
            badge_type: "pink",
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "LGS 2026",
            type: null,
            url: "/tr/paketler/lgs-2026/",
            icon: null,
            description: null,
            badge_text: "ERKEN KAYIT FIRSATI",
            badge_type: "pink",
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "11. Sınıf",
            type: null,
            url: "/tr/paketler/11-sinif/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "10. Sınıf",
            type: null,
            url: "/tr/paketler/10-sinif/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "9. Sınıf",
            type: null,
            url: "/tr/paketler/9-sinif/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "7. Sınıf",
            type: null,
            url: "/tr/paketler/7-sinif",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "6. Sınıf",
            type: null,
            url: "/tr/paketler/6-sinif",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "5. Sınıf",
            type: null,
            url: "/tr/paketler/5-sinif",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "KPSS & ALES & DGS",
            type: null,
            url: "/tr/paketler/kpss-ales-dgs/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "right",
        mobile_position: "right",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Hesap",
        url: "/u/student/stats/",
        target: "_blank",
        icon: null,
        type: "primary",
        desktop_position: null,
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: true,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Hakkımızda",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "Blog",
            type: null,
            url: "/tr/blog/",
            icon: "book-closed",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Biz Kimiz?",
            type: null,
            url: "/tr/hakkimizda/",
            icon: "users-03",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Bize Ulaşın",
            type: null,
            url: "/tr/iletisim/",
            icon: "phone",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Sıkça Sorulan Sorular",
            type: null,
            url: "/tr/sss/",
            icon: "life-buoy-02",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "",
        type: null,
        url: "",
        icon: null,
        description: "",
        badge_text: "",
        badge_type: null,
        desktop_position: null,
        mobile_position: null,
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Paketleri İncele",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "YKS 2026",
            type: null,
            url: "/tr/paketler/yks-2026/",
            icon: null,
            description: null,
            badge_text: "ERKEN KAYIT FIRSATI",
            badge_type: "pink",
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "LGS 2026",
            type: null,
            url: "/tr/paketler/lgs-2026/",
            icon: null,
            description: null,
            badge_text: "ERKEN KAYIT FIRSATI",
            badge_type: "pink",
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "11. Sınıf",
            type: null,
            url: "/tr/paketler/11-sinif/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "10. Sınıf",
            type: null,
            url: "/tr/paketler/10-sinif/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "9. Sınıf",
            type: null,
            url: "/tr/paketler/9-sinif/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "7. Sınıf",
            type: null,
            url: "/tr/paketler/7-sinif",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "6. Sınıf",
            type: null,
            url: "/tr/paketler/6-sinif",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "5. Sınıf",
            type: null,
            url: "/tr/paketler/5-sinif",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "KPSS & ALES & DGS",
            type: null,
            url: "/tr/paketler/kpss-ales-dgs/",
            icon: null,
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "right",
            mobile_position: "right",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: null,
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Lisans Aktifleştir",
        type: null,
        url: "/tr/basla/",
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [],
        desktop_position: null,
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headermenucomponent",
      data: {
        title: "Hesap",
        type: null,
        url: "/u/student/stats/",
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [],
        desktop_position: null,
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: true,
      },
    },
  ],
};
const tr_teacher = {
  name: "Eğitmen",
  language: "tr",
  profile: "teacher",
  components: [
    {
      type: "headermenucomponent",
      data: {
        title: "Kullanıcılar",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "Öğrenci",
            type: null,
            url: "/tr/",
            icon: "users-03",
            description: "Hedeflediğin netler için ihtiyacın olan herşey!",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Okul",
            type: null,
            url: "/tr/okul/",
            icon: "building-08",
            description: "Kurumunuzu Kunduz'la geleceğe taşıyın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
          {
            title: "Eğitmen",
            type: null,
            url: "/tr/egitmen/",
            icon: "pen-tool-01",
            description: "Soru çözerek ek kazanç sağlayın.",
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "left",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
  ],
};
const e_student = {
  name: "Öğrenci",
  language: "en",
  profile: "student",
  components: [
    {
      type: "headermenucomponent",
      data: {
        title: "Users",
        type: null,
        url: null,
        icon: null,
        description: null,
        badge_text: null,
        badge_type: null,
        childs: [
          {
            title: "Students",
            type: null,
            url: "/",
            icon: "users-check",
            description: null,
            badge_text: null,
            badge_type: null,
            childs: [],
            desktop_position: "left",
            mobile_position: "top",
            hide_for_authenticated_user: false,
            hide_for_unauthenticated_user: false,
          },
        ],
        desktop_position: "left",
        mobile_position: "top",
        hide_for_authenticated_user: false,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Signup",
        url: "/auth/register/",
        target: "_self",
        icon: null,
        type: "primary",
        desktop_position: "right",
        mobile_position: "bottom",
        hide_for_authenticated_user: true,
        hide_for_unauthenticated_user: false,
      },
    },
    {
      type: "headerbuttoncomponent",
      data: {
        label: "Signin",
        url: "/auth/login/",
        target: "_self",
        icon: null,
        type: "secondary",
        desktop_position: "right",
        mobile_position: "bottom",
        hide_for_authenticated_user: true,
        hide_for_unauthenticated_user: false,
      },
    },
  ],
};

export const headerItems = {
  tr_school,
  tr_student,
  tr_teacher,
  e_student,
};
